import * as PIXI from 'pixi.js'
import { settings } from '../settings'
import { getPlinkoBoxColors, isCompactPlinkoTheme } from '../../theme/plinkoTheme.config'
// import { linesNum } from './gameUI'

export const pointsPerRow = Array.from({ length: 16 }, (_, index) => 3 + index)

export const secondIndex = (arr) => Math.floor(Math.random() * (arr.length - 1))

export const ballAndPointsNewRadius = linesNum => {
  return settings.point.initialRadius - (linesNum - 8) * 1
}

export const boxNewWidth = linesNum => settings.box.width - (linesNum - 8) * 2

export const fontSize = linesNum => settings.box.fontSizeInitial - (linesNum - 8) * 2

export function splitGradientTexture (numSprites) {
  const sprites = []
  const boxColors = getPlinkoBoxColors()
  const halfColors = Math.ceil(boxColors.length / 2)
  const center = (numSprites - 1) / 2
  const maxDistance = center || 1
  for (let i = 0; i < numSprites; i++) {
    const sprite = new PIXI.Sprite(PIXI.Texture.WHITE)
    const normalizedDistance = Math.min(1, Math.abs(i - center) / maxDistance)
    const colorIndex = Math.round((1 - normalizedDistance) * (halfColors - 1))
    sprite.tint = boxColors[colorIndex]
    sprites.push(sprite)
  }
  return sprites
}
